import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, SelectItem } from 'primeng/primeng';
import { UpdateSubsciptionPlan } from '../../../../models/inModels/Subscription';
import { CreateSubscriptionFeature, SubscriptionFeature, UpdateSubscriptionFeature } from '../../../../models/inModels/SubscriptionFeatures';
import { SubscriptionFeaturesService } from "../../../../services/subscription-features.service";
import { SubscriptionPlanService } from "../../../../services/subscription.service";
import { StorageService } from '../../../../services/system/storage.service';

@Component({
	selector: 'app-subscription-plan-edit',
	templateUrl: './subscription-plan-edit.component.html',
	styleUrls: ['./subscription-plan-edit.component.css']
})
export class SubscriptionPlanEditComponent implements OnInit {
	id;
	model: UpdateSubsciptionPlan;
	createFeatureModel: CreateSubscriptionFeature;
	editFeatureModel: UpdateSubscriptionFeature;
	featureatureModel: SubscriptionFeature;
	serverFeatures: any;
	loading = false;
	error: Message[];
	categories: SelectItem[];
	displayModal: boolean = false;
	selectedFeature;
	features;
	isEditMode: boolean = false;
	frequencies: SelectItem[];
	frequency: SelectItem;
	total:number ;
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		public storageService: StorageService,
		private service: SubscriptionPlanService,
		private featureService: SubscriptionFeaturesService,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.id = this.route.snapshot.paramMap.get('Id');
		this.createFeatureModel = new CreateSubscriptionFeature();
		this.frequencies = [
			{
				label: "Monthly",
				value: 1
			},
			{
				label: "Quarterly",
				value: 3
			},
			{
				label: "Biannually",
				value: 6
			},
			{
				label: "Annual",
				value: 12
			}
		];
	}

	ngOnInit() {
		this.get();
	}

	get() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.total = result.TotalPrice;
				this.model = new UpdateSubsciptionPlan(result);
				this.frequency = this.frequencies.filter(x => x.value === this.model.LengthInMonths)[0];
				this.serverFeatures = result.SubscriptionFeatures;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.get();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	goBack(): void {
		this.router.navigate(['/subscriptions/plans']);
	}

	showModalDialog(feature?: any) {
		if (feature) {
			this.editFeatureModel = { ...feature };
			this.isEditMode = true;
			this.selectedFeature = { value: this.editFeatureModel.PropertyKey, label: this.editFeatureModel.PropertyKey }
		} else {
			this.createFeatureModel = new CreateSubscriptionFeature();
			this.createFeatureModel.AccessGranted = true;
			this.isEditMode = false;
		}

		this.displayModal = true;
	}

	initFeatureDropDown(event) {
		this.featureService.getDropdownList(event).then(
			x => {
				this.features = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setFeature(): void {
		this.createFeatureModel.Key = this.selectedFeature.value;
	}

	create() {
		this.loading = true;
		this.createFeatureModel.PlanId = this.model.Id;

		this.featureService.create(this.createFeatureModel).then(
			result => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Created successfully" });
				this.get();
				this.displayModal = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	update() {
		this.loading = true;
		this.editFeatureModel.PlanId = this.model.Id;
		this.editFeatureModel.Key = this.selectedFeature.value;
		this.featureService.update(this.editFeatureModel).then(
			result => {
				this.loading = false;
				this.editFeatureModel = new UpdateSubscriptionFeature(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Feature saved" });
				this.get();
				this.displayModal = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}


	delete(feature: SubscriptionFeature) {
		this.confirmationService.confirm({
			message: `Are you sure you want to remove <strong>${feature.Name}</strong>?`,
			header: 'Confirmation',
			icon: 'fa fa-times',
			accept: () => {
				this.loading = true;
				this.featureService.delete(feature.SubscriptionPlanId, feature.PropertyKey).then(
					result => {
						this.loading = false;
						this.get();
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	handleImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.editFeatureModel.IconPublicId = result.PublicId;
		this.createFeatureModel.IconPublicId = result.PublicId;
		this.loading = false;
	}
		
	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.editFeatureModel.IconPublicId = null;
		this.createFeatureModel.IconPublicId = null;
		this.loading = false;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/subscriptions/plans/subscription-plan-edit/subscription-plan-edit.component.ts